module.exports = __webpack_public_path__ + "static/media/loading3.f629803f.gif";